import { ulid } from "ulid";
import { v4 as uuidv4 } from "uuid";
import { UAParser } from "ua-parser-js";
import { MONTHS_EN } from "../constants/month";
import { DAY_NAMES } from "../constants/day";
import SHA256 from "crypto-js/sha256";
import MD5 from "crypto-js/md5";

export const readIpAddress = async () =>
  await fetch("https://api.ipify.org?format=json")
    .then((r) => r.json())
    .then((r) => r.ip);

export const readUserAgent = () => navigator.userAgent;

export const readDeviceInfo = () => {
  const parser = new UAParser();
  const result = parser.getResult();
  return result;
};

function isIPad() {
  const ua = navigator.userAgent || "";
  const platform = navigator.platform || "";

  // iPadOS 13+ ใช้ Mac OS X เป็น platform แต่รองรับ touch
  const isIPadOS13Plus =
    platform === "MacIntel" && navigator.maxTouchPoints > 1;

  // หรือเจอ iPad ใน UA แบบเก่า
  const isiPadUA = /iPad/.test(ua);

  return isIPadOS13Plus || isiPadUA;
}

export const readDeviceType = () => {
  const device = readDeviceInfo().device.type;
  if (device) {
    return device;
  } else {
    if (isIPad()) {
      return "tablet";
    } else {
      return "desktop/laptop";
    }
  }
};

export const formatDateTime = ({ datetime, msg }) => {
  const newDate = new Date(datetime);
  const date = newDate.getDate();
  const month = newDate.getMonth();
  const year = newDate.getFullYear();
  const hh = newDate.getHours();
  let mm = newDate.getMinutes();
  let ss = newDate.getSeconds();
  mm = mm < 10 ? `0${mm}` : mm;
  ss = ss < 10 ? `0${ss}` : ss;
  const monthName = (msg?.[MONTHS_EN[month].toLowerCase()] || "")
    .replace("Month ", "")
    .replace("month ", "")
    .replace("เดือน", "");
  const display = `${date} ${monthName} ${year}, ${hh}:${mm}:${ss}`;
  return display;
};

export const formatTimeToDateTimeV1 = (timeNumber) => {
  const newDate = new Date(timeNumber);
  const date = newDate.getDate();
  const day = newDate.getDay();
  const month = newDate.getMonth();
  const year = newDate.getFullYear();
  const hh = newDate.getHours();
  let mm = newDate.getMinutes();
  let ss = newDate.getSeconds();
  mm = mm < 10 ? `0${mm}` : mm;
  ss = ss < 10 ? `0${ss}` : ss;
  const monthName = MONTHS_EN[month];
  const dayName = DAY_NAMES[day].en;
  const display = `${dayName} ${date} ${monthName} ${year}, ${hh}:${mm}:${ss}`;
  return display;
};

// 1/12/2000 --> 2000-12-01
export const formatDateTime_ddmmyyyy_to_yyyymmdd_v1 = (ddmmyyyy) => {
  try {
    let [dd, mm, yyyy] = ddmmyyyy.split("/");
    dd = +dd < 10 ? `0${+dd}` : dd;
    mm = +mm < 10 ? `0${+mm}` : mm;
    return `${yyyy}-${mm}-${dd}`;
  } catch (error) {
    return null;
  }
};

export const generateTransactionId = ({ idNumber, ipAddress, timestamp }) => {};

export const timestampSignature = () => {};

export const readIpAddresses = async () => {
  const ipv4Promise = fetch("https://api.ipify.org?format=json")
    .then((r) => r.json())
    .then((r) => r.ip)
    .catch(() => null);

  const ipv6Promise = fetch("https://api64.ipify.org?format=json")
    .then((r) => r.json())
    .then((r) => r.ip)
    .catch(() => null);

  const [ipv4, ipv6] = await Promise.all([ipv4Promise, ipv6Promise]);
  return { ipv4, ipv6 };
};

export const calculateAge = (birthDateString) => {
  const today = new Date();
  const birthDate = new Date(birthDateString);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  if (age < 0) {
    age = 0;
  }
  return age;
};

export const onGenerateReplyToken = () => {
  const tokenWithoutDash = uuidv4().replace(/-/g, "");
  const replyToken = tokenWithoutDash;
  return replyToken;
};

export const onGenerateUUID1 = () => {
  const uuidWithoutDash = uuidv4().replace(/-/g, "");
  return uuidWithoutDash;
};

export const onGenerateULID1 = () => {
  const result = ulid();
  return result;
};

export const sha256 = (string) => {
  const hash = SHA256(string).toString();
  return hash;
};

export const md5 = (string) => {
  const hash = MD5(string).toString();
  return hash;
};

export const getHashOfDictionary = (dictionaryObject) => {
  // const keys = Object.keys(dictionaryObject);
  // const string = JSON.stringify(keys);
  const string = JSON.stringify(dictionaryObject);
  const hash = md5(string);
  return hash;
};

// export const checkLocaleIsEnglishOrThai = (text) => {
//   if (typeof text !== "string") return false;
//   const cleanedText = text.replace(/\s/g, "");
//   // ถ้ามีตัวอักษรที่ไม่ใช่ภาษาอังกฤษหรือไทย ให้ false
//   const invalidChar = /[^\u0E00-\u0E7Fa-zA-Z]/.test(cleanedText);
//   return !invalidChar;
// };

export const checkLocaleIsEnglishOrThai = (text) => {
  if (typeof text !== "string") return false;
  const cleanedText = text.replace(/\s/g, "");
  const hasThai = /[\u0E00-\u0E7F]/.test(cleanedText);
  const hasEnglish = /[a-zA-Z]/.test(cleanedText);
  // ถ้ามีทั้งไทยและอังกฤษในข้อความเดียวกัน ให้ false
  if (hasThai && hasEnglish) return false;
  // ถ้ามีตัวอักษรที่ไม่ใช่ภาษาอังกฤษหรือไทย ให้ false
  const invalidChar = /[^\u0E00-\u0E7Fa-zA-Z]/.test(cleanedText);
  return !invalidChar && (hasThai || hasEnglish);
};

export const checkFullnameIsValid = (text) => {
  if (typeof text !== "string") return false;

  // ตัดช่องว่างหัวท้าย และ Normalize กรณีมีสระวรรณยุกต์ไทย
  const normalized = text.trim().normalize("NFC");

  // ถ้าเป็นค่าว่างให้ false
  if (normalized.length === 0) return false;

  // ตรวจว่ามีทั้งไทยและอังกฤษพร้อมกันไหม
  const hasThai = /[\u0E00-\u0E7F]/.test(normalized);
  const hasEnglish = /[a-zA-Z]/.test(normalized);
  if (hasThai && hasEnglish) return false;

  // ตรวจความยาวขั้นต่ำและสูงสุด (ป้องกัน spam)
  const cleaned = normalized.replace(/[\s-]/g, "");
  if (cleaned.length < 1 || cleaned.length > 100) return false;

  // ตรวจว่ามีเฉพาะอักษรไทย (รวมช่องว่างและขีด)
  const isThaiOnly = /^[\u0E00-\u0E7F\s-]+$/.test(normalized);

  // ตรวจว่ามีเฉพาะอักษรอังกฤษ (รวมช่องว่างและขีด)
  const isEnglishOnly = /^[a-zA-Z\s-]+$/.test(normalized);

  return isThaiOnly || isEnglishOnly;
};
